/* eslint-disable quotes */
// Romeno
export const romeno = {
  start: "Începeți",
  configurations: "Setări",
  ramdom: "Modul de redare aleatorie  ",
  vibration: "Vibrație:",
  startgame: "Începeți jocul",
  save: "Salvează",
  delete: "Șterge",
  update: "Actualizare",
  lets: "Hai să jucăm",
  permanentbuy: "Achiziții permanente",
  signature: "Abonament lunar",
  signatureano: "Abonament anual",
  small: "Aici puteți folosi numele real... sau o poreclă :)",
  text1: "Obțineți acces Premium și garantați toate actualizările",
  text2: "Dacă vă abonați, puteți accesa versiunea Premium oricând doriți",
  gender: "Gen",
  male: "Masculin  ",
  female: "Femeie",
  ambos: "Ambele",
  fechar: "Închideți",
  sexualorientation: "Orientarea sexuală",
  heterosexual: "Heterosexuală",
  homosexual: "Homosexuali",
  bisexual: "Bisexuală",
  chooseavatar: "Alegeți-vă avatarul",
  Participants: "Participanți",
  participant: "Înregistrarea participanților",
  name: "Nume",
  choosecategory: "Alege categorii",
  categories: "Categorii",
  light: "Ușoară",
  preliminary: "Preliminarii",
  oral: "Orală",
  anal: "Anal",
  hot: "Fierbinte",
  extreme: "Extremă",
  vd: "Adevărul ?",
  dare: "Provocări ?",
  truth: "Adevărul",
  time: "Timp",
  createMyChallenges: "Creează-mi provocările",
  chosen: "Selectată",
  text3: "Lasă iubirea să curgă în tine!",
  text4: "Pregătește-te să trăiești intens",
  close: "Închideți",
  sele: "Selectați o opțiune",
  dev: "Dezvoltat de Dev12BR",
  game: "Joc",
  get: "Comprar - R$ 34,99",
  sign: "Assinar - R$ 5,99",
  next: "URMĂTORUL",
  config1: "De ce ar trebui să cumpăr versiunea Premium?",
  config2: "Categorii exclusive și peste 800 de provocări noi",
  config3: "Fără reclame",
  config4: "Alegeți avatare pentru a îmbunătăți",
  config5: "Creează-ți propriile provocări ",
  config6: "Sprijiniți dezvoltarea de jocuri",
  config7: "De ce are jocul un cost?",
  config8:
    "Pentru a dezvolta jocul ai nevoie de timp! :) În acest fel sprijiniți jocul, ne ajutați să îmbunătățim și să actualizăm mereu jocul.",
  config9: "Creați și editați propriile provocări",
  age: `Acest joc este destinat exclusiv adulților, așa că trebuie să aveți cel puțin 18 ani. Selectând "Da", sunteți de acord cu termenii de utilizare și cu politica de confidențialitate. 

    Acest joc este potrivit pentru cupluri, așa că trebuie să jucați cu cel puțin un partener. 
  
    Nu este o aplicație de dating, ci o modalitate de a te juca cu partenerul tău.
    `,
  config10: "Categorii exclusive",
  config11: "+ 800 de noi provocări",
  assessment:
    "Vă rugăm să o evaluați adăugând un comentariu despre aplicație. Feedback-ul dumneavoastră este foarte important pentru noi, pentru a menține jocul cât mai bun posibil.",
  agree: "Da, am peste 18 ani",
  noAgree: "Închideți aplicația",
  apoio1: "Susțineți dezvoltarea prin abonarea la versiunea Premium :)",
  apoio2: "Nu uitați să evaluați aplicația în magazinul S2",
  apoio3:
    "Obțineți acces la toate caracteristicile exclusive din versiunea Premium",
  apoio4: "Scapă de acest banner - Cumpără versiunea Premium",
  version: "Versiunea Premium",
  version1: "Versiunea Premium",
  alert1: "Înregistrați utilizatorii pentru a juca",
  alert2: "Înregistrează cel puțin încă un utilizator pentru a juca",
  alert3: "Selectați cel puțin o categorie",
  alert4: `🔥 Există participanți fără parteneri. Aveți cel puțin doi participanți pentru fiecare sex 🔞. 
        
Exemplu: doi heterosexuali sau doi homosexuali.`,
  tituloAlert1: "⚠️ Jocul este pe cale să înceapă 😜",
  tituloAlert2:
    "⚠️ Păcat 😬, Ești fără internet 📶. Porniți internetul de pe dispozitivul dumneavoastră și cumpărați abonamentul sau planul final. Și fiți fericiți😘.",
  parser: "Fără partener",
  premiumImages: "Deveniți Premium și obțineți acces la mai multe avatare",
  duvidas: "Întrebări sau sugestii - Provocări picante",
  description: "Bună ziua, întrebarea sau sugestia mea este :",
  texto99:
    "Dacă aveți probleme, întrebări sau sugestii, vă rugăm să ne trimiteți un e-mail făcând clic pe acest buton de mai jos. Așteptăm cu nerăbdare să discutăm cu dumneavoastră!",
  send: "Trimiteți",
  contact: "Contactați",
  botaoApple: "Restabilirea achizițiilor",
  alertCompra: "Achiziția dvs. este în curs de restaurare",
  NotPurchase: "Nu aveți achiziții",
  notPurchase2:
    "Acest link este numai pentru utilizatorii care au cumpărat achiziții anterioare și doresc să restaureze pe un dispozitiv nou.",
  termOfPotitic: "Termeni de utilizare și Politica de confidențialitate",
  alertDeuErrado: "Ceva a mers prost :(",
  alertDeuErrado2: "Completați toate informațiile",
  alertNome: "Completați câmpul: Nume",
  options: "Opțiunile",
  optionsTitle: "Opțiunile",
  gradualGame: "Joc gradual",
  textoCaixa:
    "Prin activarea acestei selecții, provocările vor fi graduale, adică de la cele mai ușoare la cele mai extreme, în funcție de alegerea dumneavoastră.",
  comoJogar: "Cum se joacă? 🤔",
  avalie: "Evaluați",
  novaCategoria: "Categoriile mele",
  alterLanguage: "Schimbați limba ?",
  textLanguage: "La schimbarea limbii, aplicația va fi repornită.",
  textLanguage1: "Schimbă limba",
  cancel: "Anulează",
  languages: "Limbi:",
  email: "@email",
  deletCat: "Ștergeți categoria",
  textDeletCat:
    "Prin ștergerea acestei categorii, provocările din această categorie vor fi șterse. După această acțiune, nu mai poate fi anulată.",
  deletDes: "Ștergeți provocarea",
  textDeletDes:
    "După ștergerea provocării, această acțiune nu mai poate fi anulată.",
  desafio: "Înregistrați o nouă provocare",
  desafiotexto: "Provocare",
  textoeditDesafio: "Cine poate face asta ?",
  textEmquem: "Cu cine?",
  nome: "Nume",
  inicio: "Pornirea jocului",
  inicio2:
    "Apăsând acest buton, veți fi direcționat către ecranul de înregistrare a jucătorului. 👥.",
  inicio3: "Jocul este pe cale să înceapă 🎲",
  inicio4: "Următorul",
  inicio5: "Reglaje și setări",
  inicio6: `Ajustări cum ar fi: 
  
- Provocări progresive
- Schimbarea limbajului provocărilor 
- Creați provocări 
- Sprijinirea 
- Printre altele.`,
  inicio7: "Sfârșitul",
  inicio8: `Deveniți Premium și obțineți acces la:

- Încă 450 de noi provocări 😎

- Caractere exclusive 🦸♀️ 🧑🚒

- Creează-ți propriile provocări 📝

- Păstrați jocul actualizat ✅

- Și multe altele 😍`,
  inicio9: "Ajutor",
  inicio10: "Bine ați venit la jocul Spicy Challenges 🌶",
  inicio11:
    "Vezi cât de ușor este să joci și să navighezi prin meniuri în mai puțin de 30 de secunde 😎.",
  inicio12: "Vezi tutorial 👍🏼",
  inicio13: "Nu vreau să 👎🏼",
  inicio14: `Pentru a începe jocul, trebuie să adăugați cel puțin doi (2) jucători 😀.
              
Apăsarea butonului care este indicat mai sus 👆
  
De fiecare dată când adăugați un nou utilizator, apăsați același buton 😘`,
  cadastrarCategory: "Înregistrare în categorie",
  inicio15: "Crearea unei noi categorii",
  inicio16:
    "Pasul 1 : Apăsați butonul cu semnul + care se află în partea de jos a acestui ecran. După ce apăsați, va apărea o fereastră în care veți introduce noua categorie.",
  inicio17:
    "Pasul 2: Introduceți noua dvs. categorie și faceți clic pe Salvare",
  inicio18:
    "Pasul 3: Pentru a edita această categorie sau pentru a adăuga provocările din cadrul categoriei, faceți clic pe ea.",
  inicio19:
    "Pasul 4: În ecranul următor, apăsând butonul indicat cu săgeata ⬆️, se va deschide o fereastră pentru editarea noii categorii.",
  inicio20:
    "Pasul 5: În ecranul următor, prin apăsarea butonului indicat cu săgeata ⬆️, veți șterge categoria.",
  inicio21:
    "Pasul 1: Apăsați butonul de mai jos pentru a adăuga o nouă provocare la această categorie",
  inicio22: "Crearea unei noi provocări",
  inicio23:
    "Pasul 2: Faceți clic pe fiecare element încercuit pentru a cunoaște în detaliu fiecare câmp al registrului",
  inicio24: "Textul provocării",
  inicio25: `Scrieți provocarea după bunul dumneavoastră plac, iar pentru ca numele jucătorului să fie afișat în provocare, apăsați butonul roșu de mai jos. 
    
Se vor adăuga următoarele caractere {nome}. 

** NU SCHIMBAȚI ACESTE CARACTERE ** Deoarece pentru ca numele să fie afișat corespunzător, trebuie să fie așa cum este descris mai jos ⬇️⬇️⬇️⬇️⬇️⬇️

Provocare: Sărută gâtul lui {nome}`,
  inicio26: "Cine poate face și cine poate primi",
  inicio27: `Selectați "Ambele" dacă provocarea poate fi executată și primită de participanți de "ambele" sexe.
  
În cazul în care provocarea se adresează unui singur sex, selectați-l pe cel dorit.
`,
  inicio28: "Adăugarea timpului la provocare",
  inicio29:
    'Dacă provocarea dvs. are o oră, trageți pur și simplu "intervalul" de mai jos, iar valoarea va fi afișată mai sus. După expirarea timpului de probă, se va auzi un sunet pentru a vă anunța că proba s-a încheiat.',
  aviso12: `Aici trebuie doar să creați categoria!
    
Pentru a adăuga provocări, trebuie doar să dați click pe butonul categoriei nou create ⬆️⬆️⬆️⬆️⬆️⬆️⬆️⬆️`,
  voltar: "Inapoi",
  semDe: "Jucător fără o provocare înregistrată",
  semDe2: `Înregistrați cel puțin o provocare pentru acest jucător 😬. 
  
Veți fi redirecționat către ecranul de conectare.`,
  term: "Confidențialitate",
  Potitic: "Termeni de utilizare",
  adquirited: "Achiziționat",
  camera: "Cameră",
  galery: "Galerie",
  avatar: "Avatar",
  image: "Imagine",
  seletion: " Selectată",
  editCategory: "Editați categoria",
  frase1: "Te bucuri de provocări?",
  frase2: "Ce zici să încerci Provocările Premium?",
  //err texto
  errTexto:
    "Dacă ați găsit o eroare de traducere, vă rugăm să corectați fraza în câmpul de mai jos:",
  errTitulo: "Ai observat ceva în neregulă?",
  errCorrect: "Cum ar trebui să fie în limba română?",
  thisLanguageIsCorrect: "Provocarea în LIMBA ROMÂNĂ este corectă?",
  yes: "Da",
  no: "Nu",
  errSend: "Trimiteți sugestia",

  share: "Acțiune",
  fraseShare: `Ce aplicație de top! Doar împărtășesc pentru că știu că o să-ți placă și ție!🫣
  Descărcați-l și apoi spuneți-mi dacă nu este prea bun lol...😉
  
  
  Link pentru descărcare: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇷🇴",

  morePlayer: "Joacă cu mai mulți jucători ?",
  players: "Jucători",
  carregar: "Încărcați imaginea",
  takePhoto: "Faceți o fotografie sau selectați o imagine",
  useAvatar: "Sau folosiți Avatarul",

  hetero: "Cuplu heterosexual",
  gay: "Cuplu gay",
  lesbico: "Cuplu de lesbiene",

  nomeHomem1: "James",
  nomeHomem2: "George",
  nomeMulher1: "Emily",
  nomeMulher2: "Mia",
  messageErr: "Adaugă jucătorii 🙌",
  descricaoErr: "Introduceți numele participanților ✍️.",
  why: "Spuneți-ne de ce...",
  later: "Evaluați ulterior",
  txtCard1: "E rândul tău 🔥",
  txtCard2: "Fă-o să se întâmple 😘",
  txtCard3: "Haideți! 😜",
  txtCard4: "Următoarea provocare 😈",
  txtCard5: "Încă una! 👄",

  tituloBloco1Novo: "Explorează intimitatea sexuală cu partenerul tău",
  subtitulo1Novo: "Mai mult de 1 milion de cupluri fericite",
  texto1Novo:
    "Explorează intimitatea cu partenerul tău și accesează cele mai bune jocuri pentru cupluri! Deblochează acum jocuri variate pentru a îmbunătăți conexiunea voastră!",
  tituloBloco2Novo: "Experiențe noi și o relație mai bună",
  texto2Novo1: "Bucurați-vă de +1500 provocări",
  texto2Novo2: "Creează-ți propriile provocări",
  texto2Novo3: "Categorii exclusive",
  texto2Novo4: "Fără reclame",
  texto2Novo5: "Avatare exclusive",
  texto2Novo6: "Provocări noi în fiecare zi",
  texto2Novo7: "Jocuri actualizate în mod regulat",
  tituloBloco3Novo: "Cel mai mare rating  în categorie",
  tituloBloco4Novo: "Beneficii pentru relația dumneavoastră:",
  texto4Novo1: "Intimitate",
  texto4Novo2: "Dorință",
  texto4Novo3: "Lejeritate",
  texto4Novo4: "Atracție",
  texto4Novo5: "Conexiune",
  texto4Novo6: "Plăcere",

  tituloBloco5Novo: "Ce spun cuplurile",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Cred că aceasta este cea mai bună aplicație pe care am găsit-o până acum pe mobil, atât erotică, cât și interesantă. Toate celelalte aplicații pe care le-am văzut nu se compară, așa că găsește-ți o slujbă și cumpăr-o. Nu te plânge că ești falit. Pierzi lucruri cu adevărat bune aici, iar cu doar 10,00 $ poți avea întreaga aplicație. Oferă experiențe mai bune decât jocurile pe care le găsești în magazinele locale pentru adulți.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Această aplicație este uimitoare! Am avut îndoieli dacă ar trebui să o descarc sau nu, dar cu siguranță a fost cea mai bună experiență pe care am avut-o în ultima vreme. E atât de bine să știi că încă putem face atât de multe lucruri împreună. 🤭 Am testat versiunea plătită și chiar merită, nu ajunsesem niciodată la un asemenea nivel de plăcere.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Dacă vrei să condimentezi relația, această aplicație este perfectă! Am testat deja altele, dar niciuna nu ne-a plăcut la fel de mult ca aceasta. Preludiul nostru a fost mult mai fierbinte și mai plăcut (acum imaginează-ți restul!). Merită cu adevărat să cumperi versiunea plătită (dacă vrei să simți o plăcere mai intensă), dar și versiunea gratuită ne-a surprins.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Excelent! Foarte bună într-adevăr... Ne-am excitat foarte tare în timpul jocului, ceea ce a făcut ca sexul să fie mult mai intens – plăcerea era peste tot! Așteptăm deja cu nerăbdare să jucăm din nou 💦🔥. Recomandăm și versiunea plătită, dacă puteți face față atâtor senzații 🤤.",
  tituloBloco6Novo:
    "Face ca sute de cupluri din întreaga lume și condimentează-ți relația. Descoperă peste 800 de provocări noi!",
  texto6Select: "Alegeți versiunea:",
  texto6Premium: "Premium",
  texto6Assinatura: "Abonament",
  texto6Mensal: "Abonament lunar",
  texto6Anual: "abonament anual",
  texto6Vitalicia: "licență perpetuă",
  bePremium: "Deveniți Premium",
  buyNew: "Cumpărați",
  attention: "Atenție! ",
  changeGender: "V-ați schimbat orientarea sexuală",

  tituloAvaliacao: "Îți place jocul?",
  textoAvaliacao: "Evaluează și ajută-ne să continuăm să ne îmbunătățim!",
  agoraNão: "Acum nu",
  enviarAvaliacao: "Trimite",

  nomeJogo1: "Provocări fierbinți",
  nomeJogo2: "Adevăr sau provocare?",
  nomeJogo3: "Nivel de obraznicie",
  nomeJogo4: "Ruleta Îndrăzneață",
  nomeJogo5: "Fraza zilei",
  naughtyQuiz: "Chestionar obraznic",

  playAlone: "Joacă singur",
  estaSozinho: "Ești singur?",
  selectPlayer: "Selectează jucătorul",

  skip: "Sari peste",
  responder: "Trimite",
  respondaAqui: "Răspunde aici",
  config4: "Alege avataruri pentru personalizare",

  tituloSelect1: "Joci singur?",
  tituloSelect2: "Răspunde la întrebări compromițătoare!",

  subTituloSelect1: "Te ajutăm cu o mână de ajutor!",
  subTituloSelect2: "Află cât de obraznic ești!",
  txtJogador1:
    "Alege-ți jucătorul și explorează plăceri solo ghidate, concepute special pentru tine!",
  txtJogador2: "Jucătorul selectat va răspunde la întrebări",
  tituloCena: "CE ARTICOLE VREI SĂ FOLOSEȘTI?",
  subTituloCena: `Nu ai ceva? Atinge "Obține" și achiziționează de la magazinul partener`,
  play: "Joacă",

  titleUserWarning: "Alege un utilizator",
  txtUserWarning: "Alege un utilizator pentru a răspunde la întrebări",

  resultadoQuiz1:
    "Ești o persoană rezervată, nu prea îți place să te arăți deschis sexual, preferi ceva mai romantic!",
  resultadoQuiz2:
    "Ești prea romantic pentru a exagera în privința dorințelor sexuale și preferi o atmosferă romantică, la lumina lumânărilor.",
  resultadoQuiz3:
    "Ești o persoană destul de rezervată și crezi în păstrarea aspectelor intime discreționate și private.",
  resultadoQuiz4:
    "Acest lucru nu înseamnă că nu ești uneori puțin mai îndrăzneț, dar preferi să îți păstrezi pasiunea pentru cineva special.",
  resultadoQuiz5:
    "Dorințele tale sexuale sunt în planul secund, dar asta nu schimbă faptul că există pasiune!",
  resultadoQuiz6:
    "Îți place să explorezi experiențe noi, dar întotdeauna cu respect și consimțământ.",
  resultadoQuiz7:
    "Adori întâlnirile fierbinți, pline de săruturi și tandrețe. Cu toate acestea, există o latură a ta care se bucură și de vizionarea unui film sau de o cină la lumina lumânărilor alături de persoana iubită.",
  resultadoQuiz8:
    "Ești dispus să experimentezi lucruri noi și captivante, dar întotdeauna cu responsabilitate.",
  resultadoQuiz9:
    "Ești o persoană îndrăzneață și îți place să condimentezi lucrurile în viața ta intimă din când în când.",
  resultadoQuiz10:
    "Îți place să te bucuri de toate plăcerile vieții și nu ai limite când vine vorba de sex.",
  resultadoQuiz11:
    'Cu tine, nu există moment nepotrivit și oricând este momentul potrivit pentru o escapadă rapidă! Filme romantice? Doar dacă este "50 de umbre ale lui Grey"!',
  resultadoQuiz12:
    "Pentru tine, intimitatea este o aventură constantă, și nu îți este frică să riști.",
  mes: "Lună",
  desafiosRestantesDois: "Mai aveți 2 provocări premium disponibile!",
  nenhumDesafioRestante: "Nicio provocare premium disponibilă!",
  tornePremiumAviso1:
    "Deveniți premium acum și bucurați-vă de 1000 de provocări exclusive!",
  tornePremiumAviso2:
    "Bucură-te de provocări nelimitate, conținut exclusiv și distracție fără întreruperi!",
  conteudoPremium: "Ați selectat un conținut premium!",
  aproveite4desafios:
    "Bucurați-vă de 4 provocări premium pentru a experimenta o plăcere exclusivă.",
  calculando: "Calcularea rezultatelor...",
  nivelRomantismo: "Nivelul tău de romantism este...",
  finalizar: "Finalizați",
  erroQuizTitulo: "Introduceți răspunsul dumneavoastră",
  erroQuizFrase: "Pentru a continua, introduceți răspunsul dumneavoastră!",
  new: "Aplicație Nouă",

  //resposta quiz safadeza

  resQuiz1: "Gentil",
  resQuiz2: "Pasional",
  resQuiz3: "Încântător",
  resQuiz4: "Super neastâmpărat",

  texto6Semanal: "Săptămânal",
  weekly: "Semnătură Săptămânală",

  tempSemanal: "Taxat săptămânal",
  tempMensal: "Taxat lunar",
  tempAnual: "Taxat anual",
  tempSempre: "Plată unică",
  canceleAny: "Anulează oricând",

  //Tela do safadrometro
  Low: "Scăzut",
  Medium: "Mediu",
  High: "Înalt",
  lifeTime: "Acces pe viață",
  notNow: "Nu acum, mulțumesc.",
  match: "FĂ MATCH CU A.I.",

  //Date Modal
  dateTitle: "Vrei să încerci noua noastră aplicație?",

  dateBody: `Vrei să conversezi cu roboți obraznici 😈 și să îți exersezi flirteul? O să te distrezi!🔥`,
  goToDate: "Încearcă Date.AI acum!",
  goodForU: "A FOST BINE PENTRU TINE?",
  rateOurPerformance: "Evaluează performanța noastră până acum",
  veryGood: "Foarte Bine",
  veryBad: "Foarte Rău",
  feedbackChallenge: `Ce te-ar determina să împărtășești aplicația Hot Challenges cu alte cupluri și de ce?`,
  type: "Tastează răspunsul tău aici...",
  survey: "Sondaj de satisfacție.",
  shareIfConfortable:
    "Simțiți-vă liber să împărtășiți cu prietenii dacă vă simțiți confortabil :)",

  howToPlay: "Cum să joci",
  howToPlayHotChallenge:
    "Pregătește-te să condimentezi atmosfera! Extrage o carte de provocare și surprinde-ți partenerul cu o acțiune fierbinte!",

  preGameTip1:
    "Eliberează-ți dorințele și creează momente de neuitat alături de partenerul tău!",
  preGameTip2: "Aprinde-ți pasiunile și creează momente de neuitat împreună!",
  preGameTip3:
    "Explorează-ți cele mai sălbatice dorințe și creează amintiri de neuitat!",
  preGameTip4:
    "Eliberează-ți fanteziile și bucură-te de momente de plăcere pură!",
  selecionajoagador: "E timpul să te joci",
  dica: "Sfat",
  howToPlayNaughty:
    "Selectează-ți jucăriile și obiectele preferate. Învârte roata și lasă soarta să decidă următoarea ta provocare obraznică!",
  howToPlayTruthOrDare:
    "Alege-ți soarta: spune un adevăr sau acceptă o provocare îndrăzneață. Să înceapă distracția!",
  howToKama1: "Descoperă Pozițiile Plăcerii – 365 de Zile de Pasiune!",
  howToKama2:
    "Alege o carte la întâmplare, încearcă poziția și explorați împreună noi culmi ale plăcerii!",
  kamaExplain:
    "Deblochează o nouă poziție în fiecare zi și construiește-ți colecția supremă de pasiune – călătoria ta de 365 de zile de plăcere de neuitat începe aici!",
  howToDo: "Cum să faci",
  pergunta: "Întrebare",

  restart: "Repornește",
  dialogText1HotChallenges:
    "Ai completat toate provocările disponibile cu categoriile selectate.",
  dialogText2HotChallenges:
    "Selectează mai multe categorii sau repornește jocul cu provocările actuale!",
  noChallenges: "Nici o provocare!",

  objects: "Obiecte",
  dialogText1NaughtyGames:
    "Ai completat toate provocările disponibile cu obiectele selectate.",
  dialogText2NaughtyGames:
    "Selectează mai multe obiecte sau repornește jocul cu provocările curente!",
  unlockPremium: "Deblochează Premium",
  noCategory: "Vă rugăm să alegeți cel puțin o categorie pentru a începe.",
  thanksForFeedback: "Mulțumim că ne ajuți să îmbunătățim experiența!",
  categoryKamasutra: "Alege-ți pasiunea și joacă!",
  tap: "Atinge pentru a dezvălui poziția ta!",
  step: "Ghid Pas cu Pas",
  shareQuizButton: "Împarte nivelul tău de obrăznicie!",
  tryAgain: "Încearcă din nou",
  unlockAllFun: "Deblochează toată distracția",
  limitedOffer: "Ofertă specială pentru o perioadă limitată!",
  fill: "Introduceți numele dvs. și al partenerului sau partenerei.",

  kamaNotificationTitle: "🔥 Noua ta carte a fost deblocată!",
  kamaNotificationBody:
    "Poziția ta pentru ziua {variavel} este gata. Ce zici să încerci ceva nou astăzi? 💋",

  titleNewGame: "Pregătește-te pentru Roleplay!",
  phraseNewGame:
    "În următoarea actualizare, un nou joc pentru a explora cele mai creative fantezii ale tale va sosi. Alege personaje, creează povești și ridică distracția la un nou nivel alături de partenerul tău. 🔥",
  awaitNewGame: "Așteaptă și pregătește-te să trăiești momente unice!",

  selectObjects:
    "Selectați două sau mai multe obiecte pentru a vă personaliza jocul. Explorați la maximum.",
  soon: "În curând",
  wantToBeNotify: "Vreau să fiu notificat",
  ok: "OK",
  vezDe: "ÎNTOARCERE",

  categoryLabel: "Categorie",
  descriptionLabel: "Descriere",

  loginConnect: "Autentificare",
  loginNoAccount: "Nu ai un cont?",
  loginCreateNow: "Creează acum",
  loginOrConnect: "sau conectează-te cu",

  email: "Email",
  password: "Parolă",
  loginRegister: "Înregistrare",
  loginAlreadyHas: "Ai deja un cont?",
  enterNow: "Intră acum",

  logout: "Deconectare",
  customerPortal: "Portalul Clienților",
  installApp: "Instalează aplicația",

  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/romeno.mp4",
};
